<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>


<!-- Navigation -->
<fuse-vertical-navigation 
    class="dark bg-gray-900 print:hidden"
    [appearance]="'compact'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.compact"
    [opened]="!isScreenSmall">


    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>

        <!-- Logo -->
        <div class="flex items-center justify-center h-20 mt-3 mb-4">

            <a href="/home">

                <img
                    class="w-10"
                    src="/assets/logo/logo.png"
                    alt="Logo image">

            </a>

        </div>

    </ng-container>

</fuse-vertical-navigation>





<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">



    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">



        <!-- Navigation toggle -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">


            <mat-icon
                [svgIcon]="'heroicons_outline:bars-3'">
            </mat-icon>


        </button>





        <!-- Right Actions -->

        <div class="ml-auto flex items-center gap-4">



            <!-- Language Dropdown -->
            <!-- <button
                type="button"
                class="flex items-center gap-2 px-3 py-2 rounded-lg
                       border border-gray-200
                       hover:bg-gray-100
                       transition"
                [matMenuTriggerFor]="languageMenu">


                <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_outline:language'">
                </mat-icon>



                <span class="text-sm font-medium">

                    {{
                    getLanguage() === 'eg'
                        ? 'العربي'
                        : 'English'
                    }}

                </span>



                <mat-icon
                    class="icon-size-4"
                    [svgIcon]="'heroicons_outline:chevron-down'">
                </mat-icon>


            </button>





            <mat-menu #languageMenu="matMenu">


                <button
                    mat-menu-item
                    (click)="changeLanguage('eg')">


                    <span>
                        🇪🇬 العربي
                    </span>


                </button>




                <button
                    mat-menu-item
                    (click)="changeLanguage('en')">


                    <span>
                        🇬🇧 English
                    </span>


                </button>


            </mat-menu> -->







            <!-- Logout Button -->


            <button
                type="button"
                mat-stroked-button
                color="warn"
                (click)="logout()">



                <mat-icon
                    class="icon-size-5"
                    [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'">
                </mat-icon>




                <span class="ml-2">
                    Logout
                </span>



            </button>



        </div>


    </div>







    <!-- Content -->

    <div
        class="flex flex-col flex-auto"
        style="width:100%">


        <router-outlet></router-outlet>


    </div>







    <!-- Footer -->

    <div
        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">


        <span class="font-medium text-secondary">

            TrueTech &copy; {{currentYear}}

        </span>


    </div>



</div>



<!-- Quick chat -->